import { render } from "./documentItem.vue?vue&type=template&id=7cbbaf9e"
import script from "./documentItem.vue?vue&type=script&lang=js"
export * from "./documentItem.vue?vue&type=script&lang=js"

import "./documentItem.vue?vue&type=style&index=0&id=7cbbaf9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__